<template>
  <div>
    <template v-if="isH5">
      <div class="contact-content">
        <div class="show-cont">
          <slot name="showIcon"></slot>
          <a :href="href" class="show-text">{{ showText }}</a>
        </div>
      </div>
    </template>
    <template v-else>
      <el-tooltip class="contact-content" effect="light" placement="right">
        <div class="show-cont">
          <slot name="showIcon"></slot>
          <span class="show-text">{{ showText }}</span>
        </div>

        <div slot="content" class="content">
          <span></span>
          <div class="desc-icon">
            <slot name="descIcon"></slot>
          </div>
          <div class="desc-cont" v-if="hasTrackInfo" v-observer-log="trackInfo">
            <div class="tit" v-if="title">{{ title }}</div>
            <span class="desc">{{ desc }} </span>
          </div>
          <div class="desc-cont" v-else>
            <div class="tit" v-if="title">{{ title }}</div>
            <span class="desc">{{ desc }} </span>
          </div>
        </div>
      </el-tooltip>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { isEmpty } from 'lodash-es';

export default {
  name: 'Contact',
  props: {
    showText: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    desc: {
      type: String,
      default: '',
    },
    phone: {
      type: String,
      default: '',
    },
    trackInfo: {
      type: Object,
      default: () => {},
    },
  },
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapState({
      isH5: ({ common }) => common.isH5,
    }),
    href() {
      return `tel:${this.phone || this.desc}`;
    },
    hasTrackInfo() {
      return !isEmpty(this.trackInfo);
    },
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
<style lang="scss" src="./tooltip.scss"></style>